import type Phaser from 'phaser';
import { CONFIG } from '../data/config';

/** A small wooden signpost labelling where a trail leads, placed centered on a tile. */
export function trailSign(scene: Phaser.Scene, tileX: number, tileY: number, text: string): void {
  const TS = CONFIG.tileSize;
  scene.add
    .text(tileX * TS + TS / 2, tileY * TS + TS / 2, text, {
      fontFamily: 'monospace',
      fontSize: '8px',
      color: '#fff2d0',
      backgroundColor: '#5a3a1e',
      padding: { x: 3, y: 2 },
      align: 'center',
    })
    .setOrigin(0.5, 0.5)
    .setResolution(2)
    .setDepth(80);
}
